
<ion-app [class.ion-palette-dark]="dark">
  @if(loggedIn) {
  <ion-split-pane [when]="isDesktopView" [disabled]="!isMenuVisible" contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">
      <app-menu-item></app-menu-item>
    </ion-menu>
    <div class="main-content" id="main-content" [class.has-menu-toggle]="isDesktopView">
      @if(isDesktopView) {
        <button class="menu-toggle-btn" (click)="toggleMenu()">
          <ion-icon [icon]="menuIcon"></ion-icon>
        </button>
      }
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>
  }
  @else {
  <ion-router-outlet></ion-router-outlet>
  }
</ion-app>
